//@ts-nocheck
import { Transforms, Editor, Element, Node } from 'slate'
import { JsonNode } from '../../../utils/types'
import { getSelectedCellsInATable } from '../table/utils/getSelectedCellsInATable'

const formAttributes = (oldAttributes: { style: {} }, alignment: string, allowToggleOff: boolean = false) => {
    let redactorAttributes: Partial<INodeAttrs> = {}

    if (oldAttributes) {
        redactorAttributes = {
            ...redactorAttributes,
            ...oldAttributes["redactor-attributes"]
        }
    }

    const isAlignmentToggledOff = allowToggleOff && oldAttributes?.style?.["text-align"] === alignment
    const newStyle = { ...oldAttributes?.style }
    isAlignmentToggledOff ? delete newStyle["text-align"] : newStyle["text-align"] = alignment

    const elementAttribute = {
        attrs: {
            ...oldAttributes,
            style: newStyle,
            "redactor-attributes": redactorAttributes
        }
    }

    return elementAttribute;
}
export const alignNode = (editor, alignment) => {
    Editor.normalize(editor, { force: true })
    const { selection } = editor;
    if (selection === null) {
        return
    }

    const [table] = Editor.nodes(editor, {
        match: (n: ElementWithType) => {
            return n.type === 'table'
        },
        mode: 'lowest'
    })

    const cells = table && Array.from(getSelectedCellsInATable(editor, table[1]))
    if (cells) {
        if (cells.length === 1) {
            const [cell, cellPath] = cells[0]
            if (cell.children.length === 1 && cell.children[0].type === 'fragment') {
                const elementAttribute = formAttributes(cell.children[0].attrs, alignment, true)
                Transforms.setNodes(editor, { type: 'p', ...elementAttribute }, { at: [...cellPath, 0] })
            } else {
                const [blockNode] = Editor.nodes(editor, {
                    at: selection,
                    match: (n) => Element.isElement(n) && n.type !== 'td' && n.type !== 'th' && n.type !== 'table',
                    mode: 'lowest'
                })
                if (blockNode) {
                    const elementAttribute = formAttributes(blockNode[0].attrs, alignment, true)
                    Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: selection })
                }
            }
        } else {
            cells.forEach(([cell, cellPath]) => {
                const elementAttribute = formAttributes(cell.attrs, alignment, true)
                Transforms.setNodes(editor, elementAttribute as ElementWithType, { at: cellPath })
            });
        }
    } else {
        for (const [n, p] of Editor.nodes(editor, { at: selection })) {
            const node: JsonNode = n
            const path = p
            if (Element.isElement(node) && node.type !== 'docs' && node.type !== 'table') {
                const oldAttributes: any = node.attrs
                let redactorAttributes: any = {}

                if (oldAttributes) {
                    redactorAttributes = {
                        ...redactorAttributes,
                        ...oldAttributes['redactor-attributes']
                    }
                }

                const [liNode] = Editor.nodes(editor, {
                    match: (n) => n.type === 'li',
                    at: selection,
                    mode: 'lowest'
                })

                const targetAttributes = liNode ? liNode[0].attrs : oldAttributes
                const isAlignmentToggledOff = targetAttributes?.style?.["text-align"] === alignment

                if (node.type === 'img') {
                    redactorAttributes.position = isAlignmentToggledOff ? 'none' : alignment
                }

                const newStyle = { ...targetAttributes?.style }
                isAlignmentToggledOff ? delete newStyle["text-align"] : newStyle["text-align"] = alignment

                const elementAttribute = {
                    attrs: {
                        ...(liNode ? targetAttributes : oldAttributes),
                        style: newStyle,
                        "redactor-attributes": liNode ? { ...targetAttributes?.["redactor-attributes"] } : redactorAttributes
                    }
                }

                if (liNode) {
                    Transforms.setNodes(editor, elementAttribute, { at: liNode[1] })
                    if (editor.selection) Transforms.select(editor, editor.selection)
                    return
                }
                else Transforms.setNodes(editor, elementAttribute, { at: selection })
            }
            if (editor.selection) Transforms.select(editor, editor.selection)
        }
    }

}


export const isNodeAligned = (editor, style) => {
    const selection = editor.selection;

    if (selection === null) {
        return false
    }

    const [node] = Editor.nodes(editor, { match: (n: any) => n?.attrs?.style?.["text-align"] })
    //@ts-ignore
    if (node) return node[0].attrs.style["text-align"] === style
}
